import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginTemplate from '@rexmas/rexmas-shared/lib/components/templates/login/Login';
import { useActions, useSimpleState } from '@rexmas/rexmas-shared/lib/utils/hooks';
import { login as loginAction, saveStudent as saveStudentAction } from '../../../redux/actions/session';
import { isStudentSelector } from '../../../redux/selectors/session';
import { getDomain, systemUserName, switchOptions } from '../../../utils';
import rexIcon from '../../../img/rex-logo.svg';

function Login() {
  const history = useHistory();
  const [state, setState] = useSimpleState({
    username: '',
    usernameError: '',
    password: '',
    passwordError: '',
    isPasswordShown: false,
    isLoading: false,
    isButtonActive: true,
    pathResetPassword: 'seguridad/account/reset_password/',
  });

  const [login, saveStudent] = useActions([loginAction, saveStudentAction]);
  const isStudent = useSelector(isStudentSelector);

  useEffect(() => {
    const domain = getDomain();
    saveStudent(domain);
  }, [saveStudent]);

  const userServicesUrls = [
    'https://accounts.dev.rexmas.com/login',
    'https://accounts.qa.rexmas.com/login',
    'https://accounts.rexmas.com/login',
  ];

  const makeLogin = () => {
    const { username, password } = state;
    const oauthNext = new URLSearchParams(window.location.search).get('next') || null;
    const currentPath = window.location.pathname.replace('/', '');
    let path = '';
    if ([
      'remuneraciones/es-CL/consultor/login',
      'remuneraciones/es-PE/consultor/login',
    ].includes(currentPath)) {
      path = 'login_path_consultant';
    } else if ([
      'remuneraciones/es-CL/fiscalizador/login',
      'remuneraciones/es-PE/fiscalizador/login',
    ].includes(currentPath)) {
      path = 'login_path_inspector';
    } else {
      path = 'login_path';
    }
    login(username, password, path, () => null, oauthNext).then((data) => {
      if (data) {
        if (data.next_url) {
          window.location = data.next_url;
        } else {
          window.location = '/';
        }
      } else {
        setState({ isLoading: false });
      }
    }).catch((error) => {
      if (error.response?.data?.detalle === 'user_services_login' && userServicesUrls.includes(error.response.data.next_url)) {
        window.location.replace(error.response.data.next_url);
      } else if (error.response?.data?.url) {
        history.push(error.response.data.url);
      } else {
        setState({ isLoading: false });
      }
    });
  };

  const validateData = () => {
    let usernameError = '';
    let passwordError = '';
    if (state.username.length < 1) {
      usernameError = 'Debe ingresar un usuario';
    }
    if (state.password.length < 1) {
      passwordError = 'Debe ingresar una contraseña';
    }
    if (passwordError.length > 0 || usernameError.length > 0) {
      setState({ passwordError, usernameError });
      return false;
    }
    return true;
  };

  const setPropertyChange = (prop, value) => {
    if (['username', 'password'].includes(prop)) {
      return setState({ [`${prop}Error`]: '', [prop]: value });
    }
    return setState({ [prop]: value });
  };

  const handleTextChange = (prop) => (event) => (
    setPropertyChange(prop, event.target.value)
  );

  const handleUsernameChange = (username) => (
    setPropertyChange('username', username)
  );

  const handleShowPasswordClick = () => {
    setState({ isPasswordShown: !state.isPasswordShown });
  };

  const handleButtonClick = () => {
    if (!validateData()) return;
    setState({ isLoading: true });
    makeLogin();
  };

  return (
    <LoginTemplate
      username={state.username}
      usernameError={state.usernameError}
      password={state.password}
      passwordError={state.passwordError}
      isPasswordShown={state.isPasswordShown}
      onTextChange={handleTextChange}
      onUsernameChange={handleUsernameChange}
      onShowPasswordClick={handleShowPasswordClick}
      onSubmit={handleButtonClick}
      isButtonActive={state.isButtonActive}
      isLoading={state.isLoading}
      pathResetPassword={state.pathResetPassword}
      isStudentVersion={isStudent}
      withUserSelector
      showNewPortalButton
      isAdmin
      withRememberPassword={false}
      systemUserName={systemUserName}
      logo={rexIcon}
      switchOptions={switchOptions}
    />
  );
}

export default Login;
